<script setup lang="ts">
  defineProps<{
    modelValue: boolean
  }>()

  const emit = defineEmits<{
    (event: 'update:modelValue', payload: boolean): void
  }>()

  const onChange = (event: Event) => {
    emit('update:modelValue', !!(event.target as HTMLInputElement).value)
  }
</script>

<template>
  <label class="relative inline-block h-[24px] w-[44px]">
    <input class="peer h-0 w-0 opacity-0" type="checkbox" :checked="modelValue" @change="onChange" />
    <span
      class="before:duration[0.4s] peer-focus:shadow[0 0 1px onelaunch_primary_default] dark:peer-focus:shadow[0 0 1px onelaunch_secondary_default] absolute inset-0 cursor-pointer rounded-3xl bg-onelaunch_ui_shades_700 duration-[0.4s] before:absolute before:bottom-1 before:left-1 before:h-4 before:w-4 before:rounded-[50%] before:bg-onelaunch_ui_shades_50 peer-checked:bg-onelaunch_primary_default before:peer-checked:translate-x-[20px] before:peer-checked:bg-onelaunch_ui_shades_50 dark:bg-radio_group_bg_color dark:before:bg-dark_mode_grey dark:peer-checked:bg-onelaunch_secondary_default"
    ></span>
  </label>
</template>
